import { defineStore } from 'pinia'

import type { CustomerStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useCustomerStore = defineStore('customer', {
  state: (): CustomerStore => ({
    customer: null,
    details: null,
    form: null,
    processing: 0,
    modalDelete: false,
    modalKidCreate: false,
  }),
  actions,
  getters,
})
